module.exports = __webpack_public_path__ + "img/6.e14835c4.png";